'use strict';

var _toConsumableArray = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/toConsumableArray");

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _slicedToArray = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/slicedToArray");

var _createForOfIteratorHelper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _objectSpread = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/objectSpread2");

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var cid = require('multiformats/cid');

var base58 = require('multiformats/bases/base58');

var index = require('../message/index.js');

var index$2 = require('../wantlist/index.js');

var ledger = require('./ledger.js');

var reqQueue = require('./req-queue.js');

var taskMerger = require('./task-merger.js');

var index$1 = require('../utils/index.js');

var WantType = index.BitswapMessage.WantType;
var TARGET_MESSAGE_SIZE = 16 * 1024;
var MAX_SIZE_REPLACE_HAS_WITH_BLOCK = 1024;

var DecisionEngine = /*#__PURE__*/function () {
  function DecisionEngine(peerId, blockstore, network, stats) {
    var opts = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};

    _classCallCheck(this, DecisionEngine);

    this._log = index$1.logger(peerId, 'engine');
    this.blockstore = blockstore;
    this.network = network;
    this._stats = stats;
    this._opts = this._processOpts(opts);
    this.ledgerMap = new Map();
    this._running = false;
    this._requestQueue = new reqQueue.RequestQueue(taskMerger.TaskMerger);
  }

  _createClass(DecisionEngine, [{
    key: "_processOpts",
    value: function _processOpts(opts) {
      return _objectSpread({
        maxSizeReplaceHasWithBlock: MAX_SIZE_REPLACE_HAS_WITH_BLOCK,
        targetMessageSize: TARGET_MESSAGE_SIZE
      }, opts);
    }
  }, {
    key: "_scheduleProcessTasks",
    value: function _scheduleProcessTasks() {
      var _this = this;

      setTimeout(function () {
        _this._processTasks();
      });
    }
  }, {
    key: "_processTasks",
    value: function () {
      var _processTasks2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this$_requestQueue$p, peerId, tasks, pendingSize, msg, blockCids, blockTasks, _iterator, _step, task, cid$1, blocks, _iterator2, _step2, _step2$value, topic, taskData, _cid$, blk, _iterator3, _step3, _step3$value, cidStr, block;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this._running) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                _this$_requestQueue$p = this._requestQueue.popTasks(this._opts.targetMessageSize), peerId = _this$_requestQueue$p.peerId, tasks = _this$_requestQueue$p.tasks, pendingSize = _this$_requestQueue$p.pendingSize;

                if (!(tasks.length === 0)) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return");

              case 5:
                msg = new index.BitswapMessage(false);
                msg.setPendingBytes(pendingSize);
                blockCids = [];
                blockTasks = new Map();
                _iterator = _createForOfIteratorHelper(tasks);

                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    task = _step.value;
                    cid$1 = cid.CID.parse(task.topic);

                    if (task.data.haveBlock) {
                      if (task.data.isWantBlock) {
                        blockCids.push(cid$1);
                        blockTasks.set(task.topic, task.data);
                      } else {
                        msg.addHave(cid$1);
                      }
                    } else {
                      msg.addDontHave(cid$1);
                    }
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }

                _context.next = 13;
                return this._getBlocks(blockCids);

              case 13:
                blocks = _context.sent;
                _iterator2 = _createForOfIteratorHelper(blockTasks);

                try {
                  for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                    _step2$value = _slicedToArray(_step2.value, 2), topic = _step2$value[0], taskData = _step2$value[1];
                    _cid$ = cid.CID.parse(topic);
                    blk = blocks.get(topic);

                    if (blk) {
                      msg.addBlock(_cid$, blk);
                    } else {
                      if (taskData.sendDontHave) {
                        msg.addDontHave(_cid$);
                      }
                    }
                  }
                } catch (err) {
                  _iterator2.e(err);
                } finally {
                  _iterator2.f();
                }

                if (!msg.empty) {
                  _context.next = 20;
                  break;
                }

                peerId && this._requestQueue.tasksDone(peerId, tasks);

                this._scheduleProcessTasks();

                return _context.abrupt("return");

              case 20:
                _context.prev = 20;
                _context.t0 = peerId;

                if (!_context.t0) {
                  _context.next = 25;
                  break;
                }

                _context.next = 25;
                return this.network.sendMessage(peerId, msg);

              case 25:
                _iterator3 = _createForOfIteratorHelper(blocks.entries());

                try {
                  for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                    _step3$value = _slicedToArray(_step3.value, 2), cidStr = _step3$value[0], block = _step3$value[1];
                    peerId && this.messageSent(peerId, cid.CID.parse(cidStr), block);
                  }
                } catch (err) {
                  _iterator3.e(err);
                } finally {
                  _iterator3.f();
                }

                _context.next = 32;
                break;

              case 29:
                _context.prev = 29;
                _context.t1 = _context["catch"](20);

                this._log.error(_context.t1);

              case 32:
                peerId && this._requestQueue.tasksDone(peerId, tasks);

                this._scheduleProcessTasks();

              case 34:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[20, 29]]);
      }));

      function _processTasks() {
        return _processTasks2.apply(this, arguments);
      }

      return _processTasks;
    }()
  }, {
    key: "wantlistForPeer",
    value: function wantlistForPeer(peerId) {
      var peerIdStr = peerId.toB58String();
      var ledger = this.ledgerMap.get(peerIdStr);
      return ledger ? ledger.wantlist.sortedEntries() : new Map();
    }
  }, {
    key: "ledgerForPeer",
    value: function ledgerForPeer(peerId) {
      var peerIdStr = peerId.toB58String();
      var ledger = this.ledgerMap.get(peerIdStr);

      if (!ledger) {
        return null;
      }

      return {
        peer: ledger.partner,
        value: ledger.debtRatio(),
        sent: ledger.accounting.bytesSent,
        recv: ledger.accounting.bytesRecv,
        exchanged: ledger.exchangeCount
      };
    }
  }, {
    key: "peers",
    value: function peers() {
      return Array.from(this.ledgerMap.values()).map(function (l) {
        return l.partner;
      });
    }
  }, {
    key: "receivedBlocks",
    value: function receivedBlocks(blocks) {
      if (!blocks.length) {
        return;
      }

      var _iterator4 = _createForOfIteratorHelper(this.ledgerMap.values()),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var _ledger = _step4.value;

          var _iterator5 = _createForOfIteratorHelper(blocks),
              _step5;

          try {
            for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
              var block = _step5.value;

              var want = _ledger.wantlistContains(block.cid);

              if (!want) {
                continue;
              }

              var blockSize = block.data.length;

              var isWantBlock = this._sendAsBlock(want.wantType, blockSize);

              var entrySize = blockSize;

              if (!isWantBlock) {
                entrySize = index.BitswapMessage.blockPresenceSize(want.cid);
              }

              this._requestQueue.pushTasks(_ledger.partner, [{
                topic: want.cid.toString(base58.base58btc),
                priority: want.priority,
                size: entrySize,
                data: {
                  blockSize: blockSize,
                  isWantBlock: isWantBlock,
                  haveBlock: true,
                  sendDontHave: false
                }
              }]);
            }
          } catch (err) {
            _iterator5.e(err);
          } finally {
            _iterator5.f();
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      this._scheduleProcessTasks();
    }
  }, {
    key: "messageReceived",
    value: function () {
      var _messageReceived = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(peerId, msg) {
        var ledger, cancels, wants;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                ledger = this._findOrCreate(peerId);

                if (!msg.empty) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt("return");

              case 3:
                if (msg.full) {
                  ledger.wantlist = new index$2.Wantlist();
                }

                this._updateBlockAccounting(msg.blocks, ledger);

                if (!(msg.wantlist.size === 0)) {
                  _context2.next = 8;
                  break;
                }

                this._scheduleProcessTasks();

                return _context2.abrupt("return");

              case 8:
                cancels = [];
                wants = [];
                msg.wantlist.forEach(function (entry) {
                  if (entry.cancel) {
                    ledger.cancelWant(entry.cid);
                    cancels.push(entry.cid);
                  } else {
                    ledger.wants(entry.cid, entry.priority, entry.wantType);
                    wants.push(entry);
                  }
                });

                this._cancelWants(peerId, cancels);

                _context2.next = 14;
                return this._addWants(peerId, wants);

              case 14:
                this._scheduleProcessTasks();

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function messageReceived(_x, _x2) {
        return _messageReceived.apply(this, arguments);
      }

      return messageReceived;
    }()
  }, {
    key: "_cancelWants",
    value: function _cancelWants(peerId, cids) {
      var _iterator6 = _createForOfIteratorHelper(cids),
          _step6;

      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var c = _step6.value;

          this._requestQueue.remove(c.toString(base58.base58btc), peerId);
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
    }
  }, {
    key: "_addWants",
    value: function () {
      var _addWants2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(peerId, wants) {
        var blockSizes, tasks, _iterator7, _step7, want, id, blockSize, isWantBlock, entrySize;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this._getBlockSizes(wants.map(function (w) {
                  return w.cid;
                }));

              case 2:
                blockSizes = _context3.sent;
                tasks = [];
                _iterator7 = _createForOfIteratorHelper(wants);

                try {
                  for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
                    want = _step7.value;
                    id = want.cid.toString(base58.base58btc);
                    blockSize = blockSizes.get(id);

                    if (blockSize == null) {
                      if (want.sendDontHave) {
                        tasks.push({
                          topic: id,
                          priority: want.priority,
                          size: index.BitswapMessage.blockPresenceSize(want.cid),
                          data: {
                            isWantBlock: want.wantType === WantType.Block,
                            blockSize: 0,
                            haveBlock: false,
                            sendDontHave: want.sendDontHave
                          }
                        });
                      }
                    } else {
                      isWantBlock = this._sendAsBlock(want.wantType, blockSize);
                      entrySize = blockSize;

                      if (!isWantBlock) {
                        entrySize = index.BitswapMessage.blockPresenceSize(want.cid);
                      }

                      tasks.push({
                        topic: id,
                        priority: want.priority,
                        size: entrySize,
                        data: {
                          isWantBlock: isWantBlock,
                          blockSize: blockSize,
                          haveBlock: true,
                          sendDontHave: want.sendDontHave
                        }
                      });
                    }

                    this._requestQueue.pushTasks(peerId, tasks);
                  }
                } catch (err) {
                  _iterator7.e(err);
                } finally {
                  _iterator7.f();
                }

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function _addWants(_x3, _x4) {
        return _addWants2.apply(this, arguments);
      }

      return _addWants;
    }()
  }, {
    key: "_sendAsBlock",
    value: function _sendAsBlock(wantType, blockSize) {
      return wantType === WantType.Block || blockSize <= this._opts.maxSizeReplaceHasWithBlock;
    }
  }, {
    key: "_getBlockSizes",
    value: function () {
      var _getBlockSizes2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(cids) {
        var blocks;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this._getBlocks(cids);

              case 2:
                blocks = _context4.sent;
                return _context4.abrupt("return", new Map(_toConsumableArray(blocks).map(function (_ref) {
                  var _ref2 = _slicedToArray(_ref, 2),
                      k = _ref2[0],
                      v = _ref2[1];

                  return [k, v.length];
                })));

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function _getBlockSizes(_x5) {
        return _getBlockSizes2.apply(this, arguments);
      }

      return _getBlockSizes;
    }()
  }, {
    key: "_getBlocks",
    value: function () {
      var _getBlocks2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(cids) {
        var _this2 = this;

        var res;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                res = new Map();
                _context6.next = 3;
                return Promise.all(cids.map( /*#__PURE__*/function () {
                  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(cid) {
                    var block;
                    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                      while (1) {
                        switch (_context5.prev = _context5.next) {
                          case 0:
                            _context5.prev = 0;
                            _context5.next = 3;
                            return _this2.blockstore.get(cid);

                          case 3:
                            block = _context5.sent;
                            res.set(cid.toString(base58.base58btc), block);
                            _context5.next = 10;
                            break;

                          case 7:
                            _context5.prev = 7;
                            _context5.t0 = _context5["catch"](0);

                            if (_context5.t0.code !== 'ERR_NOT_FOUND') {
                              _this2._log.error('failed to query blockstore for %s: %s', cid, _context5.t0);
                            }

                          case 10:
                          case "end":
                            return _context5.stop();
                        }
                      }
                    }, _callee5, null, [[0, 7]]);
                  }));

                  return function (_x7) {
                    return _ref3.apply(this, arguments);
                  };
                }()));

              case 3:
                return _context6.abrupt("return", res);

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      function _getBlocks(_x6) {
        return _getBlocks2.apply(this, arguments);
      }

      return _getBlocks;
    }()
  }, {
    key: "_updateBlockAccounting",
    value: function _updateBlockAccounting(blocksMap, ledger) {
      var _iterator8 = _createForOfIteratorHelper(blocksMap.values()),
          _step8;

      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var block = _step8.value;

          this._log('got block (%s bytes)', block.length);

          ledger.receivedBytes(block.length);
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }
    }
  }, {
    key: "messageSent",
    value: function messageSent(peerId, cid, block) {
      var ledger = this._findOrCreate(peerId);

      ledger.sentBytes(block.length);
      ledger.wantlist.remove(cid);
    }
  }, {
    key: "numBytesSentTo",
    value: function numBytesSentTo(peerId) {
      return this._findOrCreate(peerId).accounting.bytesSent;
    }
  }, {
    key: "numBytesReceivedFrom",
    value: function numBytesReceivedFrom(peerId) {
      return this._findOrCreate(peerId).accounting.bytesRecv;
    }
  }, {
    key: "peerDisconnected",
    value: function peerDisconnected(_peerId) {}
  }, {
    key: "_findOrCreate",
    value: function _findOrCreate(peerId) {
      var peerIdStr = peerId.toB58String();
      var ledger$1 = this.ledgerMap.get(peerIdStr);

      if (ledger$1) {
        return ledger$1;
      }

      var l = new ledger.Ledger(peerId);
      this.ledgerMap.set(peerIdStr, l);

      if (this._stats) {
        this._stats.push(peerIdStr, 'peerCount', 1);
      }

      return l;
    }
  }, {
    key: "start",
    value: function start() {
      this._running = true;
    }
  }, {
    key: "stop",
    value: function stop() {
      this._running = false;
    }
  }]);

  return DecisionEngine;
}();

exports.DecisionEngine = DecisionEngine;